
<script>
  import Carousel from 'scripts/components/basic/Carousel.vue';
  import Slide from 'scripts/components/basic/Slide.vue';
  import SubscriptionStep from 'scripts/components/basic/SubscriptionStep.vue';

  export default {
    name: 'BeanGrind',
    components: { Carousel, Slide, SubscriptionStep },
    inject: ['chooseBeanGrind'],
    template: '#step3',
    props: [
      'currentStep',
      'step1',
      'step2'
    ],
  };

</script>